import * as React from "react";
import { m } from "framer-motion";

export const MenuIcon = ({ children, noRotate, scaleMax, loopToInfinity }) => {
  return (
    <m.div
      whileHover={
        !loopToInfinity
          ? {
              scale: scaleMax ? [1, 1.25, 1.5, 1.75, 2, 1.75, 1.5, 1.25, 1] : [1, 1.25, 1],
              rotate: noRotate ? undefined : [0, 360, 0],
              borderRadius: ["50%", "50%", "50%"],
            }
          : undefined
      }
      animate={
        loopToInfinity
          ? {
              scale: scaleMax ? [1, 1.25, 1.5, 1.75, 2, 1.75, 1.5, 1.25, 1] : [1, 1.25, 1],
              rotate: noRotate ? undefined : [0, 360, 0],
              borderRadius: ["50%", "50%", "50%"],
            }
          : undefined
      }
      transition={{
        duration: !loopToInfinity ? 3 : 5,
        ease: "easeInOut",
        times: [0, 0.5, 1],
        loop: loopToInfinity ? Infinity : undefined,
      }}
      style={{
        borderRadius: "50%",
        // width: "150px",
        // height: "150px",
      }}
    >
      {children}
    </m.div>
  );
};
